import React from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import useSelectedItemsTableStyles from '../styles'

const SubAllocationTableHeader = ({ title, allocationPriceLabel }) => {
  const { t } = useTranslation()

  const selectedItemsTableClasses = useSelectedItemsTableStyles()

  return (
    <div
      className={classnames(
        selectedItemsTableClasses.row,
        selectedItemsTableClasses.container,
        selectedItemsTableClasses.headerRow
      )}
    >
      <p className={classnames(selectedItemsTableClasses.label)}>{title}</p>
      <p className={selectedItemsTableClasses.inlineField}>{t('Allocation')}</p>
      <p className={selectedItemsTableClasses.inlineField}>{t(allocationPriceLabel)}</p>
      <div className={selectedItemsTableClasses.selectedValueRemove}>{/*placeholder*/}</div>
    </div>
  )
}

export default SubAllocationTableHeader
